import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';
import type { HasMany } from '@warp-drive/legacy/model';

export type ItemStats = WithLegacy<{
  name: string | null;
  type: string | null;
  externalId: string | null;
  externalSource: string | null;
  enrichedData: Record<string, unknown> | null;
  thumbnailUrl: string | null;
  emoji: string | null;
  matchedCount: number | null;
  opinionCount: number | null;
  contextualCount: number | null;
  positiveCount: number | null;
  recommendationPct: number | null;
  sentimentClass: string | null;
  seasonBreakdown: Record<string, unknown> | null;
  createdAt: string | null;
  updatedAt: string | null;
  item: import('./item.ts').Item | null;
  mentions: HasMany<import('./mention.ts').Mention>;
  [Type]: 'item-stats';
}>;

export const ItemStatsSchema = withDefaults({
  type: 'item-stats',
  fields: [
    { name: 'name', kind: 'attribute', type: 'string' },
    { name: 'type', kind: 'attribute', type: 'string' },
    { name: 'externalId', kind: 'attribute', type: 'string' },
    { name: 'externalSource', kind: 'attribute', type: 'string' },
    { name: 'enrichedData', kind: 'attribute', type: 'object' },
    { name: 'thumbnailUrl', kind: 'attribute', type: 'string' },
    { name: 'emoji', kind: 'attribute', type: 'string' },
    { name: 'matchedCount', kind: 'attribute', type: 'number' },
    { name: 'opinionCount', kind: 'attribute', type: 'number' },
    { name: 'contextualCount', kind: 'attribute', type: 'number' },
    { name: 'positiveCount', kind: 'attribute', type: 'number' },
    { name: 'recommendationPct', kind: 'attribute', type: 'number' },
    { name: 'sentimentClass', kind: 'attribute', type: 'string' },
    { name: 'seasonBreakdown', kind: 'attribute', type: 'object' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    {
      name: 'item',
      kind: 'belongsTo',
      type: 'items',
      options: { async: true, inverse: null },
    },
    {
      name: 'mentions',
      kind: 'hasMany',
      type: 'mentions',
      options: { async: true, inverse: null },
    },
  ],
});
